import { isValidPrice } from '@domain-group/javascript-utils'
import { ProviderModel } from './types'

export type DefaultQuoteItemModel = {
  allow_toggle?: boolean,
  cache_key?: number,
  data: {
    section_title?: string,
  },
  description?: string,
  display_title?: string,
  id: number,
  internal_notes?: string,
  item_type?: string | 'custom',
  options: any,
  owner_id?: number,
  owner_type?: string,
  provider_id?: number,
  provider?: Partial<ProviderModel>,
  title: string,
  value_type: 'fixed' | 'percentage',
  value: number,
}

export type DefaultQuoteItemOption = {
  id: number,
  title?: string,
  value: {
    id: number,
    title?: string,
    price?: number,
  },
}

export type CreateMultipleDefaultQuoteItemsPayload = {
  data?: any,
  item_type: 'orderable',
  options?: DefaultQuoteItemOption[],
  order_bundle_id?: number,
  price_list_item_id?: number,
  title?: string,
}

export type DefaultQuoteItemRequestOptions = {}

const state = {
  allow_toggle: false,
  data: {
    section_title: '',
  },
  description: undefined,
  display_title: '',
  id: null,
  internal_notes: '',
  item_type: 'custom',
  owner_id: null,
  owner_type: '',
  title: '',
  value_type: 'fixed',
  value: 0,
}

export const requiredFields = [
  { key: 'title' },
  { key: 'value', validation: isValidPrice, invalidMessage: 'Invalid Value' },
  { key: 'value_type' },
]

export default state
